import { render, staticRenderFns } from "./PortalTurnoVirtual.vue?vue&type=template&id=797df512&"
import script from "./PortalTurnoVirtual.vue?vue&type=script&lang=js&"
export * from "./PortalTurnoVirtual.vue?vue&type=script&lang=js&"
import style0 from "./PortalTurnoVirtual.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports